import moment from 'moment';

export function stringToDate(value: unknown | string, format?: string): any {
    if (typeof value === 'string') {
        try {
            // Check if it's an ISO date string with timestamp (contains 'T' or 'Z')
            // These should be parsed as ISO dates to preserve time information
            const isIsoDateTime = value.indexOf('T') > -1 || value.indexOf('Z') > -1;

            if (isIsoDateTime) {
                // Parse ISO datetime strings properly (handles timezone correctly)
                const isoDate = new Date(value);
                if (!isNaN(isoDate.getTime())) {
                    if (format) {
                        return moment(isoDate).format(format);
                    }
                    return isoDate;
                }
            }

            // For date-only strings and legacy formats, use manual parsing
            // This preserves the day correctly by avoiding UTC timezone issues
            let a, d;

            if (value.indexOf(' ') > -1) {
                a = value.split(/[^0-9]/);
                d = new Date(+a[0], +a[1] - 1, +a[2], +a[3], +a[4], +a[5]);
            } else {
                a = value.split(/[^0-9]/);
                d = new Date(+a[0], +a[1] - 1, +a[2], 0, 0, 0);
            }

            if (format) {
                return moment(d).format(format);
            }

            if (+a[0] < 1900) {
                d.setUTCFullYear(+a[0]);
            }

            // Return Date object directly for better compatibility with DatePipe
            return d;
        } catch (e) {
            return new Date();
        }
    }

    return value;
}
